/**
 * « À VOIR » — le modèle de l'écran, sans navigateur (shell/AVoir.tsx).
 */

/** Après deux relevés manqués, l'indicateur ne garantit plus rien : il le dit. */
export const ECHECS_AVANT_MUET = 2

const JOUR = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' })
const HEURE = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit' })
const DATE = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', day: '2-digit', month: '2-digit' })

/** « depuis 14:05 » le jour même, « depuis le 21/10 » sinon — le jour se lit
 *  à Paris, comme l'heure affichée ; rien si la date est illisible. */
export function depuisLe(iso: string | null, maintenant = Date.now()): string | null {
  if (!iso) return null
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return null
  return JOUR.format(new Date(maintenant)) === JOUR.format(d) ? `depuis ${HEURE.format(d)}` : `depuis le ${DATE.format(d)}`
}
